import querystring, { ParsedUrlQuery } from 'querystring';
import { useSearchParams } from 'next/navigation';

const useQueryParams = (): ParsedUrlQuery => {
	const searchParams = useSearchParams();

	try {
		if (typeof window !== 'undefined') {
			return querystring.parse(window.location.search.replace('?', ''));
		}

		// Convert URLSearchParams to ParsedUrlQuery format
		const query: ParsedUrlQuery = {};
		if (searchParams) {
			searchParams.forEach((value, key) => {
				query[key] = value;
			});
		}

		return query;
	} catch {
		return {};
	}
};

export default useQueryParams;
